import React from "react";
import ReactDOM from "react-dom/client";
import "react-quill/dist/quill.snow.css";
import "jsvectormap/dist/css/jsvectormap.css";
import "react-toastify/dist/ReactToastify.css";
import "react-modal-video/css/modal-video.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import { UserProvider } from "./contexts/UserContext";
import LoaderProvider from "./components/DriftComponents/LoaderContext";
import { RackProvider } from "./components/DriftComponents/RackManagement/RackContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
   <LoaderProvider>
  {/* <RackProvider> */}
   
    <UserProvider>
      <ToastContainer
        position="top-right"
        autoClose={3000}  
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={true}
        draggable={true}
      />
      <App />
    </UserProvider>
 
    {/* </RackProvider> */}
    
   </LoaderProvider>

  </>
);

reportWebVitals();
